module.exports = __webpack_public_path__ + "json/market1-0.json?5f383473715efc2da64ed6fd58b22766";


//////////////////
// WEBPACK FOOTER
// ./src/assets/packed/market/market1-0.json
// module id = 1252
// module chunks = 3